export const kUntitledDraftName = 'Untitled draft'
